import { useBackendApi } from './backendApi';
import { PERSON_UPDATED } from './peopleService';
import { useEventsPublisher } from 'event-bus';
import { Person } from './Types';

export interface CreateExternalContactResult {
  contact: Person,
  isMatching: boolean,
}

export function useSyncContactService() {
  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const createExternalContact = async (contactId: number, connectionProfileId: number) => {
    const result = await backendApi.post(`/contacts/${contactId}/newexternalcontact`, {
      connectionProfileId,
    });

    eventsPublisher.publish(PERSON_UPDATED, {
      id: contactId,
      data: result.contact,
    });

    return result as CreateExternalContactResult;
  };

  return {
    createExternalContact,
  }
}
